import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}function n(e){let t={};for(let[n,r]of Object.entries(e))t[r]=n;return t}export{t as invert};
//# sourceMappingURL=invert-BZScEfjD.js.map